import { axiosInstance } from "./api_instance";

export default async function fetchWinners() {

    try {
        const response = await axiosInstance.get(`/winners`)
        return response

    } catch (error) {
        return error
    }
} 
